import { FC, PropsWithChildren, createContext, useCallback, useContext, useState } from 'react';

type Distributor = {
	token?: string;
	lastName?: string;
	logonId?: string;
	name?: string;
	email?: string;
};

type DpCatalogoContextType = {
	distributor: Distributor;
	onSetDistributor: (distributor: Distributor) => void;
};

const LOCAL_STORAGE_KEY_DISTRIBUTOR = 'distributor';

const getDistributorFromLocalStorage = (): Distributor => {
	if (typeof window === 'undefined') {
		return {};
	}
	const distributor = localStorage.getItem(LOCAL_STORAGE_KEY_DISTRIBUTOR);
	if (!distributor) {
		return {};
	}
	return JSON.parse(distributor);
};

const setDistributorToLocalStorage = (distributor: Distributor) => {
	if (typeof window === 'undefined') {
		return;
	}
	localStorage.setItem(LOCAL_STORAGE_KEY_DISTRIBUTOR, JSON.stringify(distributor));
};

export const DpCatalogoContext = createContext<DpCatalogoContextType>({} as DpCatalogoContextType);

export const useDpCatalogoContext = () => {
	const context = useContext(DpCatalogoContext);

	if (!context) {
		throw new Error('useDpCatalogoContext must be used within a DpCatalogoProvider');
	}
	return context;
};

export const DpCatalogoProvider: FC<PropsWithChildren> = ({ children }) => {
	const [distributor, _setDistributor] = useState<Distributor>(getDistributorFromLocalStorage());

	const onSetDistributor = useCallback((distributor: Distributor) => {
		_setDistributor(distributor);
		setDistributorToLocalStorage(distributor);
	}, []);

	return (
		<DpCatalogoContext.Provider value={{ distributor, onSetDistributor }}>
			{children}
		</DpCatalogoContext.Provider>
	);
};
